import { Component, inject, Input, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Ripple } from 'primeng/ripple';
import { Tooltip } from 'primeng/tooltip';
import { AppMenuItem } from '../menu';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, Ripple, Tooltip, MenuItemComponent],
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css']
})
export class MenuItemComponent implements OnInit {
  @Input() item!: AppMenuItem;
  @Input() depth = 0;

  layoutService = inject(LayoutService);
  private router = inject(Router);

  isExpanded = false;

  get hasChildren(): boolean {
    return !!(this.item.items?.length);
  }

  get isSlimCollapsed(): boolean {
    return (this.layoutService.isSlim() || this.layoutService.isSlimPlus())
      && !this.layoutService.state().sidebarActive
      && !this.layoutService.state().anchored;
  }

  ngOnInit(): void {
    if (this.hasChildren) {
      this.isExpanded = this.item.items!.some(child =>
        child.routerLink &&
        this.router.isActive(this.router.createUrlTree(child.routerLink), {
          paths: 'subset', queryParams: 'ignored',
          fragment: 'ignored', matrixParams: 'ignored'
        })
      );
    }
  }

  toggle(event: Event): void {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
  }
}
